module.exports = __webpack_public_path__ + "cd455783/img/splash-icon.07a7c465.svg";